import { HttpMethodEnum, QuestelServicesClient } from '@questelservices/common';
import store from '../store';
import { UserSetting } from '@/models/UserSetting';
import { UserSettingFilter } from '@/models/UserSettingFilter';
import { UserDto } from '@/models/UserDto';

export class UserService {
    private client: QuestelServicesClient;

    constructor() {
      this.client = new QuestelServicesClient(store, '');
    }

    public async getUserSettings(): Promise<UserSetting[]> {
      return await this.client.get('/api/users/current/settings');
    }

    public async getUserSettingsWithFilter(filter: UserSettingFilter): Promise<UserSetting[]> {
      const queryString = Object.keys(filter).map((key) => key + '=' + filter[key]).join('&');

      return await this.client.get(`/api/users/current/settings?${queryString}`);
    }

    public async insertUserSettings(data: UserSetting[], filter: UserSettingFilter): Promise<any> {
      const queryString = Object.keys(filter).map((key) => key + '=' + filter[key]).join('&');

      return await this.client.postJson<any>(`/api/users/current/settings?${queryString}`, data);
    }

    public async getAssignedClients(): Promise<any> {
      return await this.client.get('/api/users/assigned-clients');
    }

    public async updateAssignedClient(assignedClient: any): Promise<any> {
      return await this.client.postJson<any>('/api/users/update-clients', assignedClient);
    }

    public async getUserList(): Promise<UserDto[]> {
      return await this.client.get('/api/users/list');
    }

    public async getCommentSettings(): Promise<UserSetting[]> {
      return await this.client.get('/api/users/comment-settings');
    }

    public async updateCommentSettings(name: string, value: string|null) {
      let valueQuery = '';
      if(value) {
        valueQuery = `&value=${value}`;
      }
      return await this.client.sendRequest(HttpMethodEnum.Post, `/api/users/update-comment?name=${name}`+valueQuery,{});
    }
}
